import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageInfo} from '../../api/model/page-info';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input('pageInfo') pageInfo: PageInfo;
  @Output('onChange') onChange = new EventEmitter<PageInfo>();

  constructor() { }

  ngOnInit() {
  }

  pageChange(event) {
    if (event) {
      this.pageInfo.pageNumber = event;
      this.onChange.emit(this.pageInfo);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/pagination/pagination.component.ts